import { render, staticRenderFns } from "./KnowledgePage.vue?vue&type=template&id=22398470&scoped=true"
import script from "./KnowledgePage.vue?vue&type=script&lang=js"
export * from "./KnowledgePage.vue?vue&type=script&lang=js"
import style0 from "./KnowledgePage.vue?vue&type=style&index=0&id=22398470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22398470",
  null
  
)

export default component.exports